import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import * as bootstrap from "bootstrap";

import { SessionStoreRepository } from '../../shared/repositories/session.repository';
import { LoginResult, TestLoginOptions, TestLoginRequest } from '../../shared/models/auth.model';
import { LoadingSpinnerGrowComponent } from "../../shared/components/loading/loading-spinner-grow/loading-spinner-grow.component";
import { TranslocoDirective } from '@jsverse/transloco';
import { BreadcrumbComponent } from "../../shared/components/breadcrumb/breadcrumb.component";
import { environment } from '../../../environments/environment';

@Component({
    selector: 'web-patient-test-login-page',
    templateUrl: './test-login.component.html',
    styleUrl: './test-login.component.scss',
    imports: [CommonModule, ReactiveFormsModule, LoadingSpinnerGrowComponent, TranslocoDirective, BreadcrumbComponent]
})
export class TestLoginComponent implements OnInit {
    loginIsError: boolean = false;
    testloginOption: TestLoginOptions | null = null;
    modal: bootstrap.Modal | undefined;

    testloginOptions = {
        doctor: "doctor",
        patient: "patient"
    }

    testloginForm = new FormGroup({
        user: new FormControl(""),
        password: new FormControl(""),
        initials: new FormControl("")
    });

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private sessionService: SessionStoreRepository,

    ) { }

    ngOnInit(): void {
        if (this.sessionService.isLoggedIn()) {
            this.router.navigate(["/authenticated"]);
        }

        const element: HTMLElement = <HTMLElement>document.getElementById("testloginModal");
        this.modal = bootstrap.Modal.getOrCreateInstance(element);

        this.testloginOption = <TestLoginOptions>this.route.snapshot.paramMap.get("option");

        this.checkQueryParams();

        const isProduction: boolean = environment.production;

        if(isProduction){
            this.router.navigate(["/"]);
        }
    }

    showModal(): void {
        this.modal?.show();
    }

    hideModal(): void {
        setTimeout(() => {
            this.modal?.hide();
        }, 500)
    }

    checkQueryParams(){
        const params = this.route.snapshot.queryParams;
        const keys = Object.keys(params).map(k => k.toLowerCase());

        const isValid =
            keys.includes('userid') &&
            keys.includes('password') &&
            this.testloginOption == this.testloginOptions.patient;

        const credentials: TestLoginRequest = {
            user: params['userid'],
            password: params['password'],
            initials: ''
            };    

        if(isValid && this.testloginOption != null){
            this.authenticate(
                credentials
            );
        }
    }

    onSubmit() {
        const credentials = <TestLoginRequest>this.testloginForm.value;
        this.authenticate(credentials);
    }

    authenticate(credentials: TestLoginRequest){
        this.loginIsError = false;
        this.showModal();
        if (!this.sessionService.isLoggedIn() && this.testloginOption != null) {
            if (credentials) {
                this.sessionService.testlogin$(this.testloginOption, credentials)?.subscribe({
                    next: (loginResult: LoginResult) => {
                        if (loginResult) {
                            this.handleAuthenticatedRoute();
                        }
                    },
                    error: (message) => {
                        if (message.error) {
                            this.loginIsError = true;
                        }
                    },
                });
            } else {
                this.loginIsError = false;
            }
        } else {
            this.handleAuthenticatedRoute();
        }
    }

    handleAuthenticatedRoute() {
        setTimeout(() => {
            this.hideModal();
            sessionStorage.clear();
            this.router.navigate(["/authenticated"]);
        }, 2000);
    }

}
